// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__i_3us","title":"styles_title__7Khay","projectCardWrapper":"styles_projectCardWrapper__KZAEM","paginationWrapper":"styles_paginationWrapper___mYwO"};
module.exports.__checksum = "7abba7a061f5"